import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
export function Home() {
  return <>
      <Hero data-id="element-178" />
      <About data-id="element-179" />
    </>;
}